import * as React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import ClockRegular from './clock-regular-icon.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <ClockRegular {...validProps} />;
}
SvgComponent.iconName = 'clockRegular';

export const ClockRegularIcon = svgIconWrapper(SvgComponent);
